// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","455":"9fe1d013","488":"535652aa"}[chunkId] + ".chunk.js";
};